import { PublicKey } from '@drift-labs/sdk';
import { useCallback } from 'react';
import useDriftClient from 'src/hooks/useDriftClient';
import { COMMON_UI_UTILS } from '@drift/common';
import Env from 'src/environmentVariables/EnvironmentVariables';
import useDriftAccountsStore from 'src/stores/useDriftAccountsStore';
import { useSetupUserAccountStateAndListeners } from './useSetupUserAccountStateAndListeners';

export const useFetchAndSubscribeSubAccounts = () => {
	const driftClient = useDriftClient();
	const accountsSet = useDriftAccountsStore((s) => s.set);

	const { setupUserAccountStateAndListeners } =
		useSetupUserAccountStateAndListeners();

	const fetchAndSubscribeSubAccounts = useCallback(
		(selectedSubAccountPubKey?: PublicKey, emulate?: boolean) => {
			if (driftClient && driftClient.wallet !== Env.defaultWallet) {
				const accounts = COMMON_UI_UTILS.fetchCurrentSubaccounts(driftClient);

				if (accounts.length === 0) {
					accountsSet((s) => {
						s.userAccountNotInitialized = true;
						s.hasLoadedAccounts = true;
					});
					return false;
				}

				setupUserAccountStateAndListeners(
					selectedSubAccountPubKey,
					undefined,
					emulate
				);

				accountsSet((s) => {
					s.userAccountNotInitialized = false;
					s.hasLoadedAccounts = true;
				});

				return true;
			} else {
				return false;
			}
		},
		[driftClient, accountsSet, setupUserAccountStateAndListeners]
	);

	return { fetchAndSubscribeSubAccounts };
};
